import React from "react";

function Footer() {
  return (
    <footer className="container text-center mt-4">
      <div className="row">
        <div className="col">
          <p className="small">
            Made with love by Diana & Mafalda |{" "}
            <a className="text-success" href="mailto:hege@example.com">
              Contact us
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
